import { useState } from "react";
import { GoPerson } from "react-icons/go";
import { TbWallet } from "react-icons/tb";
import { RiBankLine } from "react-icons/ri";
import ModalElement from "../../../Common/ModalElement"
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import { validateFields, commonOnChange } from "../../../utils";

const BankDetails = ({ show, hideModal }) => {
    const [details, setDetails] = useState({
        accNo: "",
        ifscCode: "",
        accName: "",
        accNoErr: null,
        ifscCodeErr: null,
        accNameErr: null
    });

    const { accNo, ifscCode, accName, accNoErr, ifscCodeErr, accNameErr } = details;

    const onChangeHandler = (event) => commonOnChange(event, setDetails);

    const submit = () => {
        validateFields(
            {
                accNoErr: [accNo, "number"],
                ifscCodeErr: [ifscCode, "text"],
                accNameErr: [accName, "text"]
            },
            setDetails,
            () => {
                // Submit logic here
            }
        )
    }

    return <ModalElement size="lg" show={show} title={"Banking Details"} onHide={hideModal}>
        <div className="banking-details text-start mb-3">
            <h5 className="mb-3">Bank Account Information</h5>
            <div className="row">
                <div className="col-lg-4 col-md-6 mb-2">
                    <InputElement
                        label={"Account Number"}
                        placeholder={"Enter Account Number"}
                        name={"accNo"}
                        value={accNo}
                        error={accNoErr}
                        icon={<TbWallet size={20} />}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className="col-lg-4 col-md-6 mb-2">
                    <InputElement
                        label={"IFSC Code"}
                        placeholder={"Enter IFSC Code"}
                        name={"ifscCode"}
                        value={ifscCode}
                        error={ifscCodeErr}
                        icon={<RiBankLine size={20} />}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className="col-lg-4 col-md-6 mb-2">
                    <InputElement
                        label={"Account Holder Name"}
                        placeholder={"Enter Acc. Holder Name"}
                        name={"accName"}
                        value={accName}
                        error={accNameErr}
                        icon={<GoPerson size={20} />}
                        onChange={onChangeHandler}
                    />
                </div>
            </div>
        </div>
        <div className="submit-btn text-center my-4">
            <ButtonElement text={"Submit"} cssClass="small-radius mb-1" onClick={submit} variant="btn-outline-primary" />
        </div>
    </ModalElement>
}

export default BankDetails;